<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索销售项目..."
          @on-change="searchSalesCost"
          clearable
          icon="ios-search"
          style="width: 25rem; margin-right: 15px"
        >
        </Input>
        <Select
          placeholder="工厂筛选"
          v-model="selectedFactory"
          label-in-value
          multiple
          @on-clear="initList"
          @on-change="choseFactory"
          @on-open-change="getFactory"
          :loading="loadingFactory"
          style="width: 25%; margin-right: 15px"
        >
          <Option
            v-for="item in factoryList"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          placeholder="部门筛选"
          v-model="selectedDepartment"
          label-in-value
          multiple
          @on-clear="initList"
          @on-change="choseDepartment"
          @on-open-change="getDepartment"
          :loading="loadingDepartMent"
          style="width: 25%; margin-right: 15px"
        >
          <Option
            v-for="item in departmentList"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          placeholder="标签筛选"
          v-model="tags"
          label-in-value
          multiple
          @on-change="choseTags"
          style="width: 25%; margin-right: 20px"
        >
          <Option
            v-for="item in tagsList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          placeholder="停供状态筛选"
          v-model="isSupplyingStatus"
          label-in-value
          @on-change="choseIsSupplyingStatus"
          style="width: 25%; margin-right: 20px"
        >
          <Option
            v-for="item in isSupplyingList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <Select
            v-model="limit"
            size="small"
            style="width: 60px; margin-right: 20px"
            @on-change="changeLimit"
          >
            <Option
              v-for="item in limitList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
          <span>共{{ totalCounts }}条</span>
          <Page
            :total="totalCounts"
            :page-size="limit"
            @on-change="loadSalesCost"
            show-total
            simple
            style="min-width: 167px"
          />
          <Button
            type="success"
            style="margin-right: 20px"
            :loading="exportCalcSalesCostLoading"
            @click="exportCalcSalesCost()"
            >导出数据</Button
          >
          <Button
            type="primary"
            style="margin-right: 20px"
            @click="caclAllSalesCost()"
            :loading="caclAllSalesCostLoading"
            >计算全部成本</Button
          >
          <Button type="primary" @click="openCreateSalesDrawer()"
            >创建销售项目</Button
          >
        </div>
      </div>
    </div>
    
    <div class="table-wrapper" ref="tableWrapper">
      <CalcCostTable
        :tableLoading="tableLoading"
        :tableHeight="tableHeight"
        @loadSalesCost="loadSalesCost"
        @sortTable="sortTable"/>
    </div>
    <CreateSalesDrawer ref="CreateSalesDrawer" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import CalcCostTable from "./CalcCostTable";
import CreateSalesDrawer from "../SalesPage/CreateSalesDrawer.vue";
import axios from "@/utils/axios";
import _ from "lodash";

const typeToAttr = {
  materialCost: "materialCost",
  salesPrice: "price",
  transPrice: "transCost",
  promoFee: "promoFee",
  profit: "profit",
  profitability: "profitRate",
  estAging: "estAging",
  agingCost: "agingCost",
  totalCostWithAging: "totalCostWithAging",
  profitAfterAging: "profitAfterAging",
  profitRateAfterAging: "profitRateAfterAging",
  annualizedRateOfReturns: "annualizedRateOfReturns",
  manufactCost: "manufactCost",
};

export default {
  name: "caclSalesCost",
  components: {
    CalcCostTable,
    CreateSalesDrawer,
},
  data() {
    return {
      page: 0,
      tableLoading: false,
      searchText: "",
      filterQuery: {},
      limit: 20,
      selectedDepartment: [],
      selectedFactory: [],
      tags: [],
      isSupplyingStatus: "all",
      loadingDepartMent: false,
      loadingFactory: false,
      limitList: [
        { value: 20, label: "20" },
        { value: 50, label: "50" },
        { value: 100, label: "100" },
        { value: 300, label: "300" },
      ],
      tagsList: [
        {
          value: "搅拌站",
          label: "搅拌站",
        },
        {
          value: "管桩",
          label: "管桩",
        },
        {
          value: "构件",
          label: "构件",
        },
        {
          value: "管道",
          label: "管道",
        },
        {
          value: "水泥制品",
          label: "水泥制品",
        },
        {
          value: "中铁",
          label: "中铁",
        },
        {
          value: "中建",
          label: "中建",
        },
        {
          value: "中交",
          label: "中交",
        },
      ],
      isSupplyingList: [
        { value: "all", label: "全部" },
        { value: "true", label: "供货" },
        { value: "false", label: "停供" },
      ],
      editTransPrice: null,
      editPrice: null,
      editPromoFee: null,
      promoFeeIndexFile: null,
      promoFeeFile: null,
      priceIndexFile: null,
      priceFile: null,
      editJDItemCode: null,
      JDFile: null,
      JDIndexFile: null,
      transPriceIndexFile: null,
      transPriceFile: null,
      tableHeight: 300,
      caclAllSalesCostLoading: false,
      exportCalcSalesCostLoading: false,
    };
  },
  computed: {
    ...mapState({
      totalCounts: (state) => state.caclSalesCost.totalCounts,
      departmentList: (state) => state.department.departmentList,
      factoryList: (state) => state.factory.factoryList,
      userList: (state) => state.user.userList,
      user: (state) => state.auth.currentUser,
    }),
    displayTransCost: function () {},
  },
  methods: {
    ...mapActions({
      getSalesLatestCost: "caclSalesCost/getSalesLatestCostAction",
      calcAllSalesCost: "caclSalesCost/calcAllSalesCostAction",
      updateOne: "caclSalesCost/updateOneAction",
      getUsersList: "user/getUsersAction",
      getDepartmentList: "department/getDepartmentListAction",
      createSalesPrice: "salesPriceRecord/createSalesPriceAction",
      createSalesTransPrice: "salesTransCostRecord/createSalesTransPriceAction",
      createNoContactSalesPromoFeeRecord:
        "salesPromoFeeRecord/createNoContactSalesPromoFeeRecordAction",
      getFactorys: "factory/getFactorysAction",
      updateSales: "sales/updateSalesAction",
      getCompanyList: "company/getCompanyListAction",
      getFactoryList: "factory/getFactorysAction",
      getMaterials: "material/getMaterialsAction",
    }),
    searchSalesCost: _.debounce(function () {
      this.page = 0;
      this.loadSalesCost();
    }, 1000),
    async loadSalesCost(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };

      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.cusName = this.searchText;
      } else {
        delete this.filterQuery.cusName;
      }

      this.$router.push({
        path: `/home/caclSalesCost`,
        query: {
          ...this.filterQuery,
        },
      });

      try {
        this.tableLoading = true;
        const list = await this.getSalesLatestCost(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    changeLimit() {
      this.page = 0;
      this.loadSalesCost();
    },
    // 所有成本核算
    async caclAllSalesCost() {
      try {
        this.caclAllSalesCostLoading = true;
        await this.calcAllSalesCost();
        await this.loadSalesCost();
        this.$Message.success("计算完成");
        this.caclAllSalesCostLoading = false;
      } catch (error) {
        this.$Message.error("计算失败", error);
        this.caclAllSalesCostLoading = false;
      }
    },
    initList() {
      this.loadCaclMLCost();
    },
    async getDepartment(open) {
      if (open) {
        this.loadingDepartMent = true;
        await this.getDepartmentList();
        this.loadingDepartMent = false;
      }
    },
    async getFactory(open) {
      if (open) {
        this.loadingFactory = true;
        await this.getFactorys();
        this.loadingFactory = false;
      }
    },
    // 部门筛选
    choseDepartment(e) {
      if (e.length > 0) {
        const department = e.map((x) => x.value).join(",");
        this.filterQuery.department = department;
      } else {
        delete this.filterQuery.department;
      }
      this.loadSalesCost();
    },
    // 工厂筛选
    choseFactory(e) {
      if (e.length > 0) {
        const factory = e.map((x) => x.value).join(",");
        this.filterQuery.factory = factory;
      } else {
        delete this.filterQuery.factory;
      }
      this.loadSalesCost();
    },
    // 客户标签筛选
    choseTags(e) {
      if (e.length > 0) {
        const tags = e.map((x) => x.value).join(",");
        this.filterQuery.customerTags = tags;
      } else {
        delete this.filterQuery.customerTags;
      }
      this.loadSalesCost();
    },
    // 停供状态筛选
    choseIsSupplyingStatus(e) {
      switch (e.value) {
        case "all":
          delete this.filterQuery.isSupplying;
          break;
        case "true":
          this.filterQuery.isSupplying = true;
          break;

        case "false":
          this.filterQuery.isSupplying = false;
          break;
      }
      this.page = 0;
      this.loadSalesCost();
    },
    show(row, type) {
      switch (type) {
        case "price":
          row.isPriceEdit = !row.isPriceEdit;
          this.priceIndexFile = row._id;
          this.priceFile = row._id;
          if (row.calcSalesCost) {
            this.editPrice = Number((row.calcSalesCost.price ?? 0));
          } else if (row.price) {
            this.editPrice = Number((row.price.price ?? 0));
          } else {
            this.editPrice = null;
          }
          break;
        case "transPrice":
          row.isTransPriceEdit = !row.isTransPriceEdit;
          this.transPriceIndexFile = row._id;
          this.transPriceFile = row._id;
          if (row.calcSalesCost) {
            this.editTransPrice = Number((row.calcSalesCost.transCost ?? 0));
          } else if (row.transCost) {
            this.editTransPrice = Number((row.transCost.cost ?? 0));
          } else {
            this.editTransPrice = null;
          }
          break;
        case "promoFee":
          row.isPromoFeeEdit = !row.isPromoFeeEdit;
          this.promoFeeIndexFile = row._id;
          this.promoFeeFile = row._id;
          if (row.calcSalesCost) {
            this.editPromoFee = Number((row.calcSalesCost.promoFee ?? 0));
          } else if (row.promoFeeSum) {
            this.editPromoFee = Number((row.promoFeeSum ?? 0));
          } else {
            this.editPromoFee = null;
          }
          break;
        case "JD":
          row.isJDEdit = !row.isJDEdit;
          this.JDIndexFile = row._id;
          this.JDFile = row._id;
          if (row.JDItemCode) {
            this.editJDItemCode = row.JDItemCode;
          } else {
            this.editJDItemCode = null;
          }
      }
    },
    async setPrice(row) {
      row.isPriceEdit = !row.isPriceEdit;
      this.priceIndexFile = null;
      this.priceFile = null;
      let price = null;
      if (row.calcSalesCost) {
        price = row.calcSalesCost.price;
      } else if (row.price) {
        price = row.price.price;
      } else {
        price = null;
      }
      if (this.editPrice && price !== this.editPrice) {
        const startActiveDate = dayjs(new Date()).format("YYYY-MM-DD HH:mm");
        const form = {};
        form.sales = row._id;
        form.startActiveDate = startActiveDate;
        form.price = Number(this.editPrice);
        row = await this.createSalesPrice({ form });
        if (row.reCalcSalesCost) {
          row.sales.isTransPriceEdit = false;
          row.sales.isPriceEdit = false;
          row.sales.isPromoFeeEdit = false;
        }
      }
      this.editPrice = null;
      this.updateOne({ row });
    },
    async setTransCost(row) {
      row.isTransPriceEdit = !row.isTransPriceEdit;
      this.transPriceIndexFile = null;
      this.transPriceFile = null;
      let transCost = null;
      if (row.calcSalesCost) {
        transCost = row.calcSalesCost.transCost;
      } else if (row.transCost) {
        transCost = row.transCost.cost;
      } else {
        transCost = null;
      }
      if (this.editTransPrice && transCost != this.editTransPrice) {
        const startActiveDate = dayjs(new Date()).format("YYYY-MM-DD HH:mm");
        const form = {};
        form.sales = row._id;
        form.startActiveDate = startActiveDate;
        form.cost = Number(this.editTransPrice);
        row = await this.createSalesTransPrice({ form });
        if (row.reCalcSalesCost) {
          row.isTransPriceEdit = false;
          row.isPriceEdit = false;
          row.isPromoFeeEdit = false;
        }
      }
      this.editTransPrice = null;
      this.updateOne({ row });
    },
    async setPromoFee(row) {
      row.isPromoFeeEdit = !row.isPromoFeeEdit;
      this.promoFeeIndexFile = null;
      this.promoFeeFile = null;
      let promoFee = null;
      if (row.calcSalesCost) {
        promoFee = row.calcSalesCost.promoFee;
      } else if (row.promoFee) {
        promoFee = row.promoFee.fee;
      } else {
        promoFee = null;
      }
      if (this.editPromoFee && promoFee != this.editPromoFee) {
        const startActiveDate = dayjs(new Date()).format("YYYY-MM-DD HH:mm");
        const form = {};
        form.sales = row._id;
        form.startActiveDate = startActiveDate;
        form.fee = Number(this.editPromoFee);
        row = await this.createNoContactSalesPromoFeeRecord({ form });
        if (row.reCalcSalesCost) {
          row.isTransPriceEdit = false;
          row.isPriceEdit = false;
          row.isPromoFeeEdit = false;
        }
      }
      this.editPromoFee = null;
      this.updateOne({ row });
    },
    async setJDItemCode(row) {
      row.isJDEdit = !row.isJDEdit;
      this.JDIndexFile = null;
      this.JDFile = null;
      let JDItemCode = null;
      if (row.JDItemCode) {
        JDItemCode = row.JDItemCode;
      } else {
        JDItemCode = null;
      }
      if (this.editJDItemCode && JDItemCode !== this.editJDItemCode) {
        const data = {};
        data.JDItemCode = this.editJDItemCode;
        data.itemCodeConfirmed = true;
        const result = await this.updateSales({ id: row._id, data });
        row.JDItemCode = result.JDItemCode;
        await this.updateOne({ row });
      }
    },
    // 排序
    sortTable(data) {
      const sortBy = data.key;
      this.filterQuery.sortBy = typeToAttr[sortBy];
      switch (data.order) {
        case "asc":
          this.filterQuery.sortOrder = 1;
          // this.$emit("loadSalesCost");
          this.loadSalesCost();
          break;
        case "desc":
          this.filterQuery.sortOrder = -1;
          // this.$emit("loadSalesCost");
          this.loadSalesCost();
          break;
        case "normal":
          delete this.filterQuery.sortBy;
          delete this.filterQuery.sortOrder;
          // this.$emit("loadSalesCost");
          this.loadSalesCost();
          break;
      }
    },
    // 导出EXCLE数据
    async exportCalcSalesCost() {
      this.exportCalcSalesCostLoading = true;
      const res = await axios.get(`/export_calc_sales_cost`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `成本核算${dayjs().format("MM-DD-YYYY")}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      this.exportCalcSalesCostLoading = false;
    },
    openCreateSalesDrawer(row) {
      this.$refs.CreateSalesDrawer.openDrawer(row);
    },
  },
  created() {
    let query = this.$route.query;
    if (query.cusName) {
      this.searchText = query.cusName;
    }
    if (query.isSupplying === "true") {
      this.filterQuery.isSupplying = true;
      this.isSupplyingStatus = "true";
    } else if (query.isSupplying === "false") {
      this.filterQuery.isSupplying = false;
      this.isSupplyingStatus = "false";
    }
    this.loadSalesCost();
    this.getCompanyList({skip: 0, limit: 20});
    this.getFactoryList({});
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    let query = this.$route.query;
    this.getMaterials({ type: 'product', limit: 999, skip: 0 });
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center
    height 48px

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>